import React, { useState } from 'react';

import Loading from '@/components/common/Loading';

import styles from './index.module.scss';

export interface ImagePreviewProps {
  src: string;
  title?: string;
  onClose: () => void;
}

const ImagePreview: React.FC<ImagePreviewProps> = ({ src, title, onClose }) => {
  const [loading, setLoading] = useState(true);

  return (
    <div className={styles.compareModalOverlay} onClick={onClose}>
      {/* 弹窗容器 */}
      <div className={styles.compareModalDialog} onClick={(e) => e.stopPropagation()}>
        {/* 标题栏 */}
        <div className={styles.compareModalHeader}>
          <span className={styles.compareModalTitle}>{title || 'Preview'}</span>
          {/* 关闭按钮 */}
          <div className={styles.compareModalCloseBtn} onClick={onClose}>
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
              <path
                d="M17 5L5 17M5 5L17 17"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>

        {/* 内容区域 */}
        <div className={styles.compareModalBody}>
          {/* 图片容器 */}
          <div className={styles.compareModalImageWrapper}>
            {loading && (
              <div className="absolute inset-0 flex items-center justify-center z-10">
                <Loading size={40} iconColor="#ffffff" />
              </div>
            )}
            <img
              src={src}
              alt={title || 'Preview'}
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                width: 'auto',
                height: 'auto',
                objectFit: 'contain',
                opacity: loading ? 0 : 1,
                transition: 'opacity 0.3s ease-in-out',
              }}
              onLoad={() => {
                setLoading(false);
              }}
              onError={(e) => {
                const img = e.target as HTMLImageElement;
                img.src = '/images/default-cover-video.png';
                setLoading(false);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImagePreview;
